import React from "react";

interface DetailViewHeaderProps {
    title: string;
}

export const DetailViewHeader: React.FC<DetailViewHeaderProps> = ({ title }) => {
    return (
        <div className="border-bottom pb-3 mb-4">
            <span className="mb-1 fw-bolder">{title}</span>
        </div>
    );
};